import { InjectionToken } from "@angular/core";
import type { CacheServiceInterface } from "../services";

export const APP_CACHE = new InjectionToken<CacheServiceInterface>('APP_CACHE');